"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierProcessingUnitsAllocation = exports.TierTimeAllocation = exports.OrganisationTier = exports.OrganisationStatus = void 0;
var OrganisationStatus;
(function (OrganisationStatus) {
    OrganisationStatus["ACTIVE"] = "active";
    OrganisationStatus["INACTIVE"] = "inactive";
})(OrganisationStatus = exports.OrganisationStatus || (exports.OrganisationStatus = {}));
var OrganisationTier;
(function (OrganisationTier) {
    OrganisationTier["FREE"] = "free";
    OrganisationTier["STARTER"] = "starter";
    OrganisationTier["BASIC"] = "basic";
    OrganisationTier["PRO"] = "pro";
    OrganisationTier["ENTERPRISE"] = "enterprise";
})(OrganisationTier = exports.OrganisationTier || (exports.OrganisationTier = {}));
var TierTimeAllocation;
(function (TierTimeAllocation) {
    TierTimeAllocation[TierTimeAllocation["FREE"] = 300] = "FREE";
    TierTimeAllocation[TierTimeAllocation["STARTER"] = 1800] = "STARTER";
    TierTimeAllocation[TierTimeAllocation["BASIC"] = 108000] = "BASIC";
    TierTimeAllocation[TierTimeAllocation["PRO"] = 400000] = "PRO";
    TierTimeAllocation[TierTimeAllocation["ENTERPRISE"] = -1] = "ENTERPRISE";
})(TierTimeAllocation = exports.TierTimeAllocation || (exports.TierTimeAllocation = {}));
var TierProcessingUnitsAllocation;
(function (TierProcessingUnitsAllocation) {
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["FREE"] = 300] = "FREE";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["STARTER"] = 1800] = "STARTER";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["BASIC"] = 108000] = "BASIC";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["PRO"] = 400000] = "PRO";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["ENTERPRISE"] = -1] = "ENTERPRISE";
})(TierProcessingUnitsAllocation = exports.TierProcessingUnitsAllocation || (exports.TierProcessingUnitsAllocation = {}));
